import { Preferences } from "@capacitor/preferences";
import { isNativePlatform, STORAGE_KEYS } from "./storage";

/**
 * Course progress type definition
 */
export interface CourseProgress {
    [workshopId: string]: {
      [courseClassesId: string]: boolean;
    };
  }
  
  /**
   * Get course progress from storage
   */
  export const getCourseProgress = async (): Promise<CourseProgress> => {
    try {
      if (isNativePlatform()) {
        const { value } = await Preferences.get({ key: STORAGE_KEYS.COURSE_PROGRESS });
        if (value) {
          try {
            return JSON.parse(value) as CourseProgress;
          } catch (error) {
            console.error('Error parsing course progress:', error);
            return {};
          }
        }
        return {};
      } else {
        const value = localStorage.getItem(STORAGE_KEYS.COURSE_PROGRESS);
        if (value) {
          try {
            return JSON.parse(value) as CourseProgress;
          } catch (error) {
            console.error('Error parsing course progress:', error);
            return {};
          }
        }
        return {};
      }
    } catch (error) {
      console.error('Error getting course progress:', error);
      return {};
    }
  };
  
  /**
   * Set course progress in storage
   */
  export const setCourseProgress = async (progress: CourseProgress): Promise<void> => {
    try {
      const value = JSON.stringify(progress);
      if (isNativePlatform()) {
        await Preferences.set({
          key: STORAGE_KEYS.COURSE_PROGRESS,
          value,
        });
      } else {
        localStorage.setItem(STORAGE_KEYS.COURSE_PROGRESS, value);
      }
    } catch (error) {
      console.error('Error setting course progress:', error);
    }
  };
  
  /**
   * Remove course progress from storage
   */
  export const removeCourseProgress = async (): Promise<void> => {
    try {
      if (isNativePlatform()) {
        await Preferences.remove({ key: STORAGE_KEYS.COURSE_PROGRESS });
      } else {
        localStorage.removeItem(STORAGE_KEYS.COURSE_PROGRESS);
      }
    } catch (error) {
      console.error('Error removing course progress:', error);
    }
  };

  /**
   * Synchronous fallback for legacy compatibility
   * Use these only when async is not possible (like router context initialization)
   */
  export const getCourseProgressSync = (): CourseProgress => {
    if (typeof window === 'undefined') return {};
    const value = localStorage.getItem(STORAGE_KEYS.COURSE_PROGRESS);
    if (value) {
      try {
        return JSON.parse(value) as CourseProgress;
      } catch (error) {
        console.error('Error parsing course progress:', error);
        return {};
      }
    }
    return {};
  };